import { render, staticRenderFns } from "./LocationsResultList.vue?vue&type=template&id=6b584851&"
import script from "./LocationsResultList.vue?vue&type=script&lang=js&"
export * from "./LocationsResultList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports